module.exports = __webpack_public_path__ + "media/SOC/suspended-f31855b4.svg";